import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.background_white};
  display: flex;
  overflow-x: hidden; 
  padding: 0 1rem;

  @media (max-width: 951px) {
    flex-direction: column;
    align-items: center;
  }
  
  .title {
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.primary};
  }

  h2 {
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 700;
    margin: 1rem 0;
  }

  svg {
    height: 2rem;
    font-size: 3rem;
  }

  .displayNone {
    display: none;
  }

  @media (max-width: 951px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Content = styled.div`
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;

  .tableContent {
    display: block;
    overflow-x: auto; 
    white-space: nowrap; 

    table {
      border-spacing: 0;
      font-size: 1rem;
      width: 70rem;

      .absolute {
        position: absolute;
        color: red;
      }

      button {
        background: none;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 3rem;
      }

      .MuiCheckbox-colorSecondary {
        color: ${({ theme }) => theme.colors.tertiary_500};
      }

      td {
        opacity: 1;
      }
    }

    .opacity {
      background: ${({ theme }) => theme.colors.background};
      text-align: center;
    }

    .alterOpcaity {
      background: ${({ theme }) => theme.colors.background_white};
      text-align: center;
    }

    .dataBorder {
      border-bottom: 1px solid ${({ theme }) => theme.colors.background};
      text-align: center;
    }

    .dataOpacity {
      background: ${({ theme }) => theme.colors.background};
      border-bottom: 1px solid ${({ theme }) => theme.colors.background};
      text-align: center;
    }

    .textTable {
      border-bottom: 1px solid ${({ theme }) => theme.colors.text_gray}!important;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.text_gray};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 150px;
    }

    .checkCenter {
      text-align: center;
    }
  }

  .contacts {
    .contact { 
      p {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.primary};
        width: 100%;
      }
      
      .inputContainer{
        display: flex;
        align-items: center;

        .iconVerifiedField {
          color: ${({ theme }) => theme.colors.tertiary_500};
        }

        .iconNotVerifiedField {
          color: ${({ theme }) => theme.colors.error_500};
        } 
      }
    }
  }

  @media (max-width: 768px){
    
  }
  
  .icons {
    display: grid;
    justify-items: center;
    padding: 1rem 0 0 0;
    margin: 0.3rem;
    fill: ${({ theme }) => theme.colors.tertiary_500};

    p {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 400;
      font-size: 20px;
    }
  }

  .displayNone {
    display: none;
  }

  @media (max-width: 900px) {
    width: 100%;
  }
  
  @media (max-width: 320px) {
    padding: 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
  width: 100%;

  @media (max-width: 768px) {
    justify-content: center;
  }

  button {
    width: auto;
    max-width: 220px;
    height: 3rem;
    font-size: 1rem;
    border-radius: 0.5rem;
    padding: 0 2rem;
    
    @media (max-width: 768px) {
      width: 90%;
      max-width: 180px;
    }
    
    @media (max-width: 600px) {
      width: 100%;
      max-width: 160px;
    }
  }
`;
